import PrivateRoute, { Router } from '@Components/app-layout/PrivateRoute';

import TransactionsGridLayout from './containers/Grid';

export default function TransactionsLayout() {
  return <Router>
    <PrivateRoute path="/offer/allocations/:id/transactions" component={TransactionsGridLayout} />
  </Router>
}

